<template>
    <div class="modal micromodal-slide squirrel-file-upload" :id="viewID" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" @click="closeModalViaOverlay">
            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-image-settings">
                <ul class="tabs">
                    <li :class="{'active-tab': activeTab === 'library'}">
                        <a href="#" @click.prevent="switchTab('library')">Library</a>
                    </li>
                    <li :class="{'active-tab': activeTab === 'upload'}">
                        <a href="#" @click.prevent="switchTab('upload')">Upload</a>
                    </li>
                    <li v-if="type==='image'" :class="{'active-tab': activeTab === 'unsplash'}">
                        <a href="#" @click.prevent="switchTab('unsplash')">
                            <img src="/images/unsplash-logo.svg" width="15"/>
                            Unsplash
                        </a>
                    </li>
                </ul>

                <div class="modal__content">
                    <div class="library" v-if="activeTab === 'library'">
                        <div class="placeholders" v-if="!library_loaded">
                            <div class="placeholder-items">
                                <div class="item" v-for="n in 18">
                                    <div class="placeholder-image"></div>
                                </div>
                            </div>
                        </div>
                        <div class="files" :class="{'image-has-been-selected': selectedImage !== null}">
                            <div class="item" v-if="library_loaded" v-for="image in gallery">
                                <label :for="'file-' + image.id + '-' + viewID" :class="{'selected-image': selectedImage && image.url === selectedImage.url}">
                                    <i class="icon ion-md-checkmark-circle" v-if="selectedImage && image.url === selectedImage.url"></i>
                                    <img v-if="image.thumbnail" :src="image.thumbnail" width="100"/>
                                    <img v-if="!image.thumbnail" :src="image.icon" width="100" class="file-icon"/>
                                    <span>{{image.name}}</span>
                                    <input type="radio" :id="'file-' + image.id + '-' + viewID" :value="image" v-model="selectedImage"/>
                                </label>
                            </div>
                        </div>
                        <vuetable-pagination
                            ref="pagination"
                            @vuetable-pagination:change-page="onLibraryChangePage"
                        ></vuetable-pagination>
                    </div>
                    <div class="library" v-if="activeTab === 'upload'">
                        <vue-dropzone
                            ref="myVueDropzone"
                            id="dropzone"
                            :options="dropzoneOptions"
                            @vdropzone-success="dropzoneSuccess"
                            @vdropzone-complete="dropzoneCompleted" />
                    </div>
                    <div class="library" v-if="activeTab === 'unsplash'">
                        <input type="text" class="search" placeholder="Search for an image by keywords" @keyup="searchUnsplash"/>
                        <div class="placeholders" v-if="!unsplash_loaded">
                            <div class="placeholder-items">
                                <div class="item" v-for="n in 30">
                                    <div class="placeholder-image"></div>
                                    <div class="placeholder-text"></div>
                                </div>
                            </div>
                        </div>
                        <div class="files" v-if="unsplash_loaded" :class="{'image-has-been-selected': selectedImage !== null}">
                            <div class="item" v-for="image in unsplash">
                                <label :for="'file-' + image.id" :class="{'selected-image': selectedImage && image.url === selectedImage.url}" style="width: 100%; height: 100%;">
                                    <i class="icon ion-md-checkmark-circle" v-if="selectedImage && image.urls.regular === selectedImage.urls.regular"></i>
                                    <img :src="image.urls.thumb + '&fit=max'" width="100"/>
                                    <span>by {{image.user.first_name}} {{image.user.last_name}}</span>
                                    <input type="radio" :id="'file-' + image.id" :value="image" v-model="selectedImage"/>
                                </label>
                            </div>
                        </div>
                        <vuetable-pagination
                            ref="pagination"
                            @vuetable-pagination:change-page="onUnsplashChangePage"
                        ></vuetable-pagination>
                    </div>
                </div>

                <div class="modal__footer">
                    <button class="btn" @click.prevent="closeModal" aria-label="Close this dialog window">Close</button>
                    <button class="btn btn-success" :disabled="selectedImage === null" @click.prevent="selectImage">Select</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import PaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin';
    import qs from 'qs';

    export default {
		components: {
            vueDropzone: vue2Dropzone,
            VuetablePagination,
		},
        props: {
            label: {
                type: String,
                default: 'Set featured image',
            },
            name: {
                type: String,
                required: true,
            },
            value: {
                default: null,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: 'image'
            },
            endpoint: {
                type: String,
                default: '/api/media/handle'
            },
            group:{
                type: Object
            },
            opened: {
                type: Boolean
            },
            avatar: {
                type: Boolean,
                default: false
            },
            avatar_id: {
                default: false,
            },
        },
        data() {
            return {
                activeTab: 'library',
                selectedImage: null,
                gallery: [],
                unsplash: [],
                files: [],
                unsplash_loaded: false,
                unsplashCurrentPage: 1,
                library_loaded: false,
                libraryCurrentPage: 1,
                libraryLastPage: null,
                query: null,
                uppyFileUpload: null,
                modalOpened: false,
                dropzoneOptions: {
                    url: this.endpoint,
                    thumbnailWidth: 150,
                    maxFilesize: 12,
                    maxFiles: 5,
                    headers: {
                        'X-CSRF-TOKEN' : window.axios.defaults.headers.common['X-CSRF-TOKEN']
                    },
                    params: {
                        group: typeof this.group !== 'undefined' ? this.group.id : null
                    }
                }
            }
        },
        computed: {
            viewID(){
                return this.name;
            },
        },
        mounted() {
            MicroModal.init({
                disableScroll: true,
                onClose: modal => this.closeModal(),
            });

            if(this.avatar === true){
                this.endpoint = "/api/media/avatar/" + this.avatar_id;
                this.dropzoneOptions.url = "/api/media/avatar/" + this.avatar_id;
                console.log(this.dropzoneOptions.url);
            }

            this.dropzoneOptions.params.group = typeof this.group !== 'undefined' ? this.group.id : null;
            console.log('Group:' + this.group);
        },
        methods: {
            switchTab(switchTo){
                this.selectedImage = null;
                this.activeTab = switchTo;

                if(switchTo === 'unsplash'){
                    this.loadUnsplash();
                } else if(switchTo === 'library'){
                    this.loadGallery();
                }
            },
            loadGallery(page = 0){
                var queryString = qs.stringify({
                    page: page
                });

                this.library_loaded = false;
                axios.get('/api/media/list?' + queryString).then((response) => {
                    this.library_loaded = true;
                    this.libraryCurrentPage = response.data.current_page ?? 1;
                    this.libraryLastPage = response.data.last_page;
                    this.gallery = response.data.data;

                    if( this.$refs.pagination ){
                        this.$refs.pagination.setPaginationData(response.data);
                    }
                }, (response) => {
                    this.error = response;
                });
            },
            loadUnsplash(query = null, page = 1){
                let req = '/api/media/unsplash';

                var queryString = qs.stringify({
                    query: query,
                    page: page,
                });

                this.unsplash_loaded = false;

                req = req + "?" + queryString;

                axios.get(req).then((response) => {
                    this.unsplash_loaded = true;
                    this.$refs.pagination.setPaginationData({
                        total: response.data.total ?? 9999,
                        per_page: 30,
                        current_page: page,
                        last_page: response.data.total_pages ?? 334,
                        next_page_url: "",
                        prev_page_url: "",
                        from: 1,
                        to: response.data.total_pages ?? 334,
                    });
                    this.unsplash = response.data.results ?? response.data;
                }, (response) => {
                    console.error(response);
                    this.error = response;
                });

            },
            closeModalViaOverlay(el){
                if(el.target.className === "modal__overlay" ){
                    this.$emit('closedModal', true);
                }
            },
            closeModal(el){
                this.$emit('closedModal', true);
            },
            selectImage(){
                if(this.selectedImage !== null){
                    this.$emit('input', [this.selectedImage]);
                    this.$emit('closedModal', true);
                }
            },
            searchUnsplash($event){
                var self = this;

                this.unsplash_loaded = false;
                this.query = $event.target.value;

                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                this.timer = setTimeout(() => {
                    let searchTerm = $event.target.value;
                    self.loadUnsplash(searchTerm);
                }, 800);
            },
            dropzoneCompleted( response ){
                //console.log(response);
                //this.$emit('input', [this.selectedImage]);
                this.$emit('closedModal', true);
            },
            dropzoneSuccess( files, response ){
                //console.log(files);
                this.$emit('input', response.files);
                this.$emit('closedModal', true);
                //console.log(response);
            },
            onLibraryChangePage(page){
                this.libraryCurrentPage = page;
                this.loadGallery(page);
            },
            onUnsplashChangePage(page){
                this.unsplashCurrentPage = page;
                this.loadUnsplash(this.query, page)
            }
        },
        watch: {
            files(files) {
                this.$emit('input', this.multiple ? files.url || null : files[0].url || null);
            },
            avatar_id(avatar_id) {
                if(this.avatar === true){
                    this.dropzoneOptions.url = "/api/media/avatar/" + this.avatar_id;
                    this.endpoint = "/api/media/avatar/" + this.avatar_id;
                    console.log(this.dropzoneOptions.url);
                }
            },
            opened: {
                handler (val, oldVal) {
                    if(val === true){
                        MicroModal.show(this.name);
                        this.loadGallery();
                    }else{
                        this.$emit('closedModal', true);
                        MicroModal.close(this.name);
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    $base-color: #e7e7e7;
    $shine-color: #e8e8e8;
    $animation-duration: 1.6s;
    $avatar-offset: 52 + 16;

    @mixin background-gradient {
        background-image: linear-gradient(90deg, $base-color 0px, $shine-color 40px, $base-color 80px);
        background-size: 600px;
    }

    .squirrel-file-upload {
        .modal__container{
            width: 780px;
        }

        .tabs{
            border-bottom: 1px solid #e0e5ea;
            padding:0;

            li{
                border-right: 1px solid #e0e5ea;
                padding: 0 !important;
                margin-bottom: 0 !important;

                &:before{
                    content: '';
                    display: none;
                }
                &.active-tab{
                    background-color: #f5f5f5;

                    a:hover{
                        background-color: #f5f5f5;
                    }
                }

                a{
                    display: block;
                    padding: 16px 10px;
                    min-width: 150px;
                    text-decoration: none;
                    font-size: 14px;
                    color: #546b81;
                    line-height: 22px;

                    &:hover{
                        background-color: #fcfcfc;
                    }


                    img{
                        margin-right: 5px;
                    }

                }
            }
        }
        .modal__content{
            background-color: #fcfcfc;
            margin: 0;
            min-height: 300px;
            padding: 20px 30px;

            .library{
                .files, .placeholder-items{
                    display: flex;
                    flex-wrap: wrap;

                    .item {
                        width: 16.6%;
                        padding: 4px;
                    }

                    .placeholder-image {
                        width: 100%;
                        height: 65px;
                        // background-color: white;
                        @include background-gradient();
                        animation: shine-avatar $animation-duration infinite linear;
                        border-radius: 4px;
                    }

                    
                }
                .placeholder-items {
                    @for $i from 1 through 30 {
                        .item:nth-of-type(#{$i}) {
                            $min: 45;
                            $max: 100;
                            $rand: random();
                            $width: $min + floor($rand * (($max - $min) +1)) * 1%;
                            .placeholder-text {
                                height: 11px;
                                width: $width;
                                margin-top: 2px;
                                margin-bottom: 4px;
                                border-radius: 4px;
                                // background-color: white;
                                @include background-gradient();
                                animation: shine-lines $animation-duration infinite linear;

                                &::after {
                                    content: $width;
                                }
                            }
                        }
                    }
                }
                .search{
                    background: #f1f3f4;
                    border: none;
                    width: 100%;
                    outline: none;
                    margin-bottom: 20px;
                }
                .image-has-been-selected{
                    img{
                        opacity: 0.5;

                    }
                    label.selected-image img{
                        opacity: 1;
                    }
                }
                label{
                    position: relative;
                    display: block;

                    img{
                        display: block;
                        object-fit: cover;
                        width: 100%;
                        height: 65px;
                        object-position: center 0%;
                        max-width: 100%;
                        border-radius: 4px;
                        cursor: pointer;

                        &.file-icon{
                            object-fit: initial;
                        }
                    }

                    i{
                        position: absolute;
                        font-size: 24px;
                        left: 5px;
                        top: 1px;
                        color: white;
                        text-shadow: 1px 1px #a7a7a7;
                    }

                    input[type='radio']{
                        visibility: hidden;
                        display: none;
                    }

                    span{
                        display: block;
                        font-size: 11px;
                        line-height: 16px;
                        color: rgba(55, 53, 47, 0.4);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin-top: 2px;
                        margin-bottom: 4px;
                    }
                }
            }
        }
    }

    .vue-dropzone{
        border: 2px dashed #e5e5e5;
        border-radius: 4px;

        .dz-message{
            font-size: 14px;
        }
    }

    @keyframes shine-lines {
        0% {
            background-position: -100px
        }
        
        40%, 100% {
            background-position: 140px
        }
    }

    @keyframes shine-avatar {
    0% {
        background-position: -100px + $avatar-offset
    }
    
    40%, 100% {
        background-position: 140px + $avatar-offset
    }
    }
</style>
